import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class RegistrationStore {

    private readonly completed = signal(false);

    markCompleted() {
        this.completed.set(true);
    }

    clear() {
        this.completed.set(false);
    }

    hasCompletedRegistration() {
        return this.completed();
    }
}

